module.exports = __webpack_public_path__ + "img/chart-tree-map.5e475537.svg";